export default "__VITE_ASSET__CkZhuikT__"